import React from 'react';

export default function Suggestions({ type, noFound, suggestions, totalCount, fetchData, goToSelectTest }) {
    return (
        <div className='suggestion-container' style={{ top: type === 'select-test' ? 52 : '' }}>
            <ul>
                <div
                    dataLength={suggestions && suggestions?.length} //This is important field to render the next data
                    next={totalCount > suggestions?.length ? fetchData : ''}
                    hasMore={true}
                >
                    {
                        suggestions !== undefined && suggestions.length > 0 ?
                            suggestions.map((items, i) => {

                                return (

                                    <li onClick={() => goToSelectTest({ ...items, testType: 0 })} >
                                        {
                                            noFound ?
                                                <div className='text-center'>No Results found</div> :
                                                <div className="container-fluid">
                                                    <div className="d-flex justify-content-between align-items-center" >
                                                        <h3>
                                                            {items?.referenceName}
                                                        </h3>
                                                        <div className='skill-tags'>
                                                            {items?.referenceTypeId === 1 ?
                                                                <div className='skill-tag'>
                                                                    <img src='/images/test-icon.svg' alt='' /> &nbsp;Test
                                                                </div> :
                                                                items?.referenceTypeId === 2 ?
                                                                    <div className='skill-tag'>
                                                                        <img src='/images/role.svg' alt='' /> &nbsp;Role
                                                                    </div> :
                                                                    items?.referenceTypeId === 3 ?
                                                                        <div className='skill-tag'>
                                                                            <img src='/images/category.svg' alt='' /> &nbsp;Category
                                                                        </div> :
                                                                        items?.referenceTypeId === 4 ?
                                                                            <div className='skill-tag'>
                                                                                <img src='/images/coding.svg' alt='' /> &nbsp;Coding Language
                                                                            </div> :
                                                                            null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </li>
                                )
                            }) : null
                    }
                </div>
            </ul>
        </div>
    )
}
